import React from 'react';
import { SwipeableDrawer, Tab, Tabs } from '@material-ui/core';

interface Props {
    tosSource: string | null;
    showTabs: boolean;
    tabIndex: number;
    onClose: () => void;
    onChange: (_: any, value: number) => void;
}

const TermsAndPrivecyAndCaliforniaNoticeDrawer = ({
    tosSource,
    showTabs,
    tabIndex,
    onClose,
    onChange,
}: Props) => (
    <>
        <SwipeableDrawer
            anchor="bottom"
            open={!!tosSource}
            onClose={onClose}
            onOpen={() => console.log('open')}
        >
            {showTabs && (
                <Tabs
                    style={{ justifyContent: 'center' }}
                    value={tabIndex}
                    onChange={onChange}
                    aria-label="simple tabs example"
                >
                    <Tab label="Staples" />
                    <Tab label="Easy Rewards" />
                </Tabs>
            )}
            {tabIndex === 0 && (
                <iframe
                    id="privacy-link"
                    title="privacy link iFrame"
                    style={{ height: '90vh', width: '100%', marginTop: 16 }}
                    src={tosSource || '#'}
                />
            )}
            {tabIndex === 1 && (
                <iframe
                    id="privacy-link"
                    title="privacy link iFrame"
                    style={{ height: '90vh', width: '100%', marginTop: 16 }}
                    src={tosSource || '#'}
                />
            )}
        </SwipeableDrawer>
    </>
);

export default TermsAndPrivecyAndCaliforniaNoticeDrawer;
